var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',_vm._g(_vm._b({attrs:{"close-on-click-modal":false,"fullscreen":_vm.fullscreen},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._t("header")]},proxy:true}],null,true)},'el-dialog',_vm.props,false),_vm.$listeners),[_vm._t("body")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }